module.exports = __webpack_public_path__ + "img/04.12f9846a.png";